import React from 'react';
import { motion } from 'framer-motion';
import Icon from './Icons';
import { ZT_PILLARS, FLOW_STEPS } from '../data/catalog';

const Security = () => (
  <section className="band band-line" id="security">
    <div className="wrap">
      <motion.div
        className="section-head"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <span className="eyebrow-dark">Security &amp; Deployment</span>
        <h2>Zero Trust by design, zero-touch by default</h2>
        <p>
          Security is not a final gate &mdash; it is embedded in identity, network, workload, and
          pipeline from the first commit.
        </p>
      </motion.div>

      <div className="zt-grid">
        {ZT_PILLARS.map((z, i) => (
          <motion.div
            key={z.h}
            className="zt-card"
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: i * 0.05 }}
          >
            <Icon name={z.icon} className="zt-icon" size={34} />
            <h4>{z.h}</h4>
            <p>{z.p}</p>
          </motion.div>
        ))}
      </div>

      <div className="zerotouch-box">
        <div>
          <h3>What &ldquo;zero-touch&rdquo; means at JbnWorks</h3>
          <p>
            No engineer logs into a production console. Every change &mdash; infrastructure,
            application, or configuration &mdash; is proposed as code, reviewed, and released by the
            pipeline. It&apos;s faster, and it removes the single biggest source of outages: manual change.
          </p>
        </div>
        <div className="flow-steps">
          {FLOW_STEPS.map((s, i) => (
            <React.Fragment key={s}>
              <span className="flow-step">{s}</span>
              {i < FLOW_STEPS.length - 1 && <span className="flow-arrow">&rarr;</span>}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Security;
